var exports = {
  "N1": "ChannelHeader.module__headerContainer___ZjYtQW",
  "dL": "ChannelHeader.module__headerWrapper___ZjYtQW",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___ZjYtQW",
  "hE": "ChannelHeader.module__headerContainerCallActive___ZjYtQW",
  "Ud": "ChannelHeader.module__headerLeftSection___ZjYtQW",
  "Gv": "ChannelHeader.module__backButton___ZjYtQW",
  "wK": "ChannelHeader.module__backButtonDesktop___ZjYtQW" + " " + "ChannelHeader.module__backButton___ZjYtQW",
  "j2": "ChannelHeader.module__backIcon___ZjYtQW",
  "Ir": "ChannelHeader.module__backIconBold___ZjYtQW" + " " + "ChannelHeader.module__backIcon___ZjYtQW",
  "CY": "ChannelHeader.module__leftContentContainer___ZjYtQW",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___ZjYtQW",
  "BN": "ChannelHeader.module__mobileButton___ZjYtQW",
  "Vt": "ChannelHeader.module__desktopButton___ZjYtQW" + " " + "ChannelHeader.module__mobileButton___ZjYtQW",
  "R3": "ChannelHeader.module__avatarWrapper___ZjYtQW",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___ZjYtQW",
  "_D": "ChannelHeader.module__groupDmHeaderInner___ZjYtQW",
  "ab": "ChannelHeader.module__groupDmEditIcon___ZjYtQW",
  "HA": "ChannelHeader.module__channelName___ZjYtQW",
  "$7": "ChannelHeader.module__groupDmChannelName___ZjYtQW",
  "kf": "ChannelHeader.module__dmNameWrapper___ZjYtQW",
  "a1": "ChannelHeader.module__userTag___ZjYtQW",
  "p": "ChannelHeader.module__channelIcon___ZjYtQW",
  "ml": "ChannelHeader.module__caretRight___ZjYtQW",
  "Nj": "ChannelHeader.module__channelInfoContainer___ZjYtQW",
  "u8": "ChannelHeader.module__followButton___ZjYtQW",
  "B6": "ChannelHeader.module__topicDivider___ZjYtQW",
  "zm": "ChannelHeader.module__topicContainer___ZjYtQW",
  "yu": "ChannelHeader.module__topicButton___ZjYtQW",
  "Am": "ChannelHeader.module__topicButtonOverflow___ZjYtQW",
  "lY": "ChannelHeader.module__headerRightSection___ZjYtQW",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___ZjYtQW",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___ZjYtQW",
  "gb": "ChannelHeader.module__iconButton___ZjYtQW",
  "f5": "ChannelHeader.module__iconButtonDefault___ZjYtQW" + " " + "ChannelHeader.module__iconButton___ZjYtQW",
  "vR": "ChannelHeader.module__iconButtonSelected___ZjYtQW" + " " + "ChannelHeader.module__iconButton___ZjYtQW",
  "rB": "ChannelHeader.module__updateIconButton___ZjYtQW" + " " + "ChannelHeader.module__iconButton___ZjYtQW",
  "l_": "ChannelHeader.module__updateIcon___ZjYtQW",
  "Do": "ChannelHeader.module__updateIconSpinning___ZjYtQW" + " " + "ChannelHeader.module__updateIcon___ZjYtQW",
  "bx": "ChannelHeader.module__updateIconSpin___ZjYtQW",
  "IC": "ChannelHeader.module__iconButtonMobile___ZjYtQW",
  "iA": "ChannelHeader.module__buttonIcon___ZjYtQW",
  "qt": "ChannelHeader.module__buttonIconMobile___ZjYtQW",
  "Dm": "ChannelHeader.module__iconButtonWrapper___ZjYtQW",
  "W9": "ChannelHeader.module__unreadPinIndicator___ZjYtQW",
};

module.exports = exports;
